import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c9e4e4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view audit" }
const _hoisted_2 = { class: "audit__header" }
const _hoisted_3 = { class: "audit__header--left" }
const _hoisted_4 = { class: "audit__title" }
const _hoisted_5 = { class: "audit__title-link" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("(back to user)")
const _hoisted_7 = { class: "audit__header-right" }
const _hoisted_8 = { class: "search" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons search__icon" }, "search", -1))
const _hoisted_10 = { class: "audit__utils" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "audit__utils-left" }, null, -1))
const _hoisted_12 = { class: "audit__utils-right" }
const _hoisted_13 = {
  key: 0,
  class: "audit__table"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"audit__table-head\" data-v-1c9e4e4c><div class=\"audit__table-row\" data-v-1c9e4e4c><div class=\"audit__table-cell table__date\" data-v-1c9e4e4c>Date</div><div class=\"audit__table-cell table__action\" data-v-1c9e4e4c>Action</div><div class=\"audit__table-cell table__details\" data-v-1c9e4e4c>Details</div><div class=\"audit__table-cell table__action-by\" data-v-1c9e4e4c>Action by</div></div></div>", 1)
const _hoisted_15 = { class: "audit__table-body" }
const _hoisted_16 = { class: "audit__table-cell table__date" }
const _hoisted_17 = { class: "audit__table-cell table__action" }
const _hoisted_18 = { class: "audit__table-cell table__details" }
const _hoisted_19 = { class: "audit__table-cell table__action-by" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "audit__utils" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "audit__utils-left" }, null, -1))
const _hoisted_23 = { class: "audit__utils-right" }
const _hoisted_24 = { class: "pagination" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "chevron_left", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "pagination__numbers" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "of", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "chevron_right", -1))
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _createTextVNode("Complete Log - " + _toDisplayString(_ctx.currentUser) + " ", 1),
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: { name: 'UserDetailsView', params: {id: _ctx.props.id} }
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "search__input",
            placeholder: "Type to search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tableBody.searchValue) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchAudit && _ctx.searchAudit(...args)))
          }, null, 544), [
            [_vModelText, _ctx.tableBody.searchValue]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Pagination, {
          options: _ctx.tableBody,
          maxCount: _ctx.auditCount,
          onPaginChange: _ctx.paginChange
        }, null, 8, ["options", "maxCount", "onPaginChange"])
      ])
    ]),
    (_ctx.audit.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.audit, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "audit__table-row",
                key: item?.externalId
              }, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.returnDate(item.created)), 1),
                _createElementVNode("div", _hoisted_17, _toDisplayString(item.action), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("pre", null, _toDisplayString(item.details), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  (item.manager)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'ModeratorDetailsView', params: {id: item.manager.externalId} }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.actionBy(item)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  (!item.manager)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.actionBy(item)), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            class: "pagination__button pagination__button--prev",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
          }, _hoisted_26),
          _createElementVNode("span", _hoisted_27, [
            _createTextVNode(_toDisplayString(_ctx.minCount) + "-" + _toDisplayString(_ctx.maxCount) + " ", 1),
            _hoisted_28,
            _createTextVNode(" " + _toDisplayString(_ctx.auditCount), 1)
          ]),
          _createElementVNode("button", {
            class: "pagination__button pagination__button--next",
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
          }, _hoisted_30)
        ]),
        _createVNode(_component_Pagination, {
          options: _ctx.tableBody,
          maxCount: _ctx.auditCount,
          onPaginChange: _ctx.paginChange
        }, null, 8, ["options", "maxCount", "onPaginChange"])
      ])
    ])
  ]))
}